(() => {
  const initializeSection = (root) => {
    if (!root || root.dataset.componentCardsReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const variantMap = JSON.parse(root.querySelector('[data-complete-variant-map]')?.textContent || '[]');
    const componentMap = JSON.parse(root.querySelector('[data-complete-component-map]')?.textContent || '{}');
    const variantInput = root.querySelector('input[name="id"]');
    if (!variantInput) return;

    const optionGroups = {
      buds: root.dataset.optionNameBuds,
      mouse: root.dataset.optionNameMouse,
      sleeve: root.dataset.optionNameSleeve,
    };

    const findOptionGroup = (optionName) => Array.from(root.querySelectorAll('.product-form__input')).find((group) => {
      const label = group.querySelector('legend, label');
      return label?.textContent.trim().startsWith(optionName);
    });

    const updateOptionAvailability = () => {
      const stockStatus = root.dataset.stockStatus || 'Sold out';

      Object.entries(optionGroups).forEach(([kind, optionName]) => {
        const group = findOptionGroup(optionName);
        if (!group) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const component = (componentMap[kind] || []).find((item) => item.option === input.value);
          const unavailable = Boolean(component && !component.available) || input.disabled || input.classList.contains('disabled');
          const label = input.nextElementSibling;
          input.toggleAttribute('data-melo-unavailable', unavailable);
          if (unavailable) input.setAttribute('aria-label', `${input.value} — ${stockStatus}`);
          else input.removeAttribute('aria-label');
          label?.toggleAttribute('data-melo-unavailable', unavailable);
        });

        group.querySelectorAll('select option').forEach((option) => {
          const component = (componentMap[kind] || []).find((item) => item.option === option.value);
          const unavailable = Boolean(component && !component.available) || option.disabled;
          const originalLabel = option.dataset.meloOriginalLabel || option.textContent;
          const cleanLabel = originalLabel
            .replace(/\s*(?:-|—|–|:)\s*(?:sold out|out of stock|unavailable|tidak tersedia|stok habis|habis stok)\s*$/i, '')
            .trim();
          option.dataset.meloOriginalLabel = cleanLabel;
          option.toggleAttribute('data-melo-unavailable', unavailable);
          option.textContent = cleanLabel;
        });
      });
    };

    const updateComponentLinks = (variantId = variantInput.value) => {
      const selected = variantMap.find((variant) => String(variant.id) === String(variantId));
      if (!selected) return;

      Object.entries({ buds: selected.buds, mouse: selected.mouse, sleeve: selected.sleeve }).forEach(([kind, option]) => {
        const component = (componentMap[kind] || []).find((item) => item.option === option);
        const card = root.querySelector(`[data-complete-component="${kind}"]`);
        if (!component || !card) return;

        const url = new URL(component.url, window.location.origin);
        url.searchParams.set('variant', component.variantId);
        card.href = url.toString();
        const variantLabel = card.querySelector('[data-component-variant]');
        if (variantLabel) variantLabel.textContent = component.option;
      });
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]')) requestAnimationFrame(updateComponentLinks);
      if (event.target.matches('.product-form__input input, .product-form__input select')) requestAnimationFrame(updateOptionAvailability);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== String(sectionId)) return;
        if (!root.isConnected) {
          unsubscribeVariantChange();
          return;
        }
        updateOptionAvailability();
        updateComponentLinks(data.variant?.id);
      });
    }

    root.dataset.componentCardsReady = 'true';
    updateOptionAvailability();
    updateComponentLinks();
  };

  const initialize = () => {
    document.querySelectorAll('.noir-melo-complete-bundle').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.noir-melo-complete-bundle').forEach(initializeSection);
  });
})();
